import _ from 'lodash';
import vue from 'vue';

const SET_DEFAULT_AV_EQUIPMENTS = (state, data) => {
  state.defaultAvEquipments = data;
};

const SET_AVS = (state, avs) => {
  state.avs = avs;
};

const SET_SKIP_EQUIPMENT_SELECTION = (state, flag) => {
  state.skipEquipmentSelection = flag;
};

const SET_VEHICLE_EQUIPMENT_LIST = (state, list) => {
  state.vehicleEquipmentList = list;
};

const SET_SELECTED_EQUIPMENTS = (state, payload) => {
  state.selectedEquipments = payload;
};

const SET_TEMPORARY_EQUIPMENT_AVS = (state, option) => {
  // when updating an option (eg by selecting an equipment), update temporary equipment avs array
  for (let i = 0; i < option.selections.length; i++) {
    if (option.selections[i].selectedAvs === null ||
      option.selections[i].selectedAvs === '-1' ||
      (option.selections[i].selectedAvs && option.selections[i].selectedAvs[0] === '-1')) {
      // remove avs from temporaryEquipmentAvs if selectedAvs is -1 or NULL
      for (let j = 0; j < option.selections[i].avs.length; j++) {
        state.temporaryEquipmentAvs = state.temporaryEquipmentAvs.filter(av => av !== option.selections[i].avs[j].av.av);
      }
    } else if (option.selections[i].selectedAvs !== undefined) {
      if (option.selections[i].selectedAvs.constructor === Array) {
        // add all avs to temporaryEquipmentAvs if selectedAvs is array
        for (let j = 0; j < option.selections[i].selectedAvs.length; j++) {
          for (let k = 0; k < option.selections[i].avs.length; k++) {
            if (option.selections[i].selectedAvs[j] === option.selections[i].avs[k].av.id) {
              state.temporaryEquipmentAvs.push(option.selections[i].avs[k].av.av);
            }
          }
        }
        for (let k = 0; k < option.selections[i].avs.length; k++) {
          for (let j = state.temporaryEquipmentAvs.length - 1; j >= 0; j--) {
            if ((state.temporaryEquipmentAvs[j] === option.selections[i].avs[k].av.av) &&
              !option.selections[i].selectedAvs.includes(option.selections[i].avs[k].av.id)) {
              state.temporaryEquipmentAvs.splice(j, 1);
            }
          }
        }
      } else {
        // add single av to temporaryEquipmentAvs
        for (let k = 0; k < option.selections[i].avs.length; k++) {
          if (option.selections[i].selectedAvs === option.selections[i].avs[k].av.id) {
            state.temporaryEquipmentAvs.push(option.selections[i].avs[k].av.av);
          }
          for (let l = 0; l < state.temporaryEquipmentAvs.length; l++) {
            // also check all the other avs in selections.avs, if they are in the temporary equipments,
            // because they have to be removed
            if ((state.temporaryEquipmentAvs[l] === option.selections[i].avs[k].av.av) &&
              (option.selections[i].avs[k].av.id !== option.selections[i].selectedAvs)) {
              state.temporaryEquipmentAvs.splice(l, 1);
            }
          }
        }
      }
    }
  }

  state.temporaryEquipmentAvs = _.uniq(state.temporaryEquipmentAvs);
};

const UPDATE_AVS_GROUP = (state, res) => {
  const avGroupName = res.avGroup;
  const avGroup = res.data;
  state.avs.options.forEach((option) => {
    let resetFlag = false;
    if (option.avGroup === avGroupName) {
      resetFlag = true;
    }
    if (resetFlag) {
      vue.set(option, 'show', false);
      option.selectedAvs = null;
    }
  });
  if (avGroup.mandatoryAvs) {
    state.avs.mandatoryAvs = state.avs.mandatoryAvs ? [...state.avs.mandatoryAvs, ...avGroup.mandatoryAvs] : avGroup.mandatoryAvs;
  }
  if (avGroup.options && avGroup.options.length) {
    state.avs.options.forEach((option) => {
      if (option.avGroup === avGroup.options[0].avGroup) {
        option.selections = avGroup.options[0].selections;
        option.show = true;
      }
    });
  }
};

const HIDE_AV_GROUPS = (state, av) => {
  let hideGroup = false;
  for (const option of state.avs.options) {
    if (!hideGroup) hideGroup = option.avGroup === av.avGroup;
    if (hideGroup) vue.set(option, 'show', false);
  }
};

export default {
  SET_DEFAULT_AV_EQUIPMENTS,
  SET_AVS,
  SET_SKIP_EQUIPMENT_SELECTION,
  SET_VEHICLE_EQUIPMENT_LIST,
  SET_SELECTED_EQUIPMENTS,
  SET_TEMPORARY_EQUIPMENT_AVS,
  UPDATE_AVS_GROUP,
  HIDE_AV_GROUPS
}
